import { configureStore } from "@reduxjs/toolkit";
import modelsReducer from "./ModelsSlice";

const store = configureStore({
  reducer: {
    models: modelsReducer,
  },
});

export default store;
